import { Component, OnInit } from '@angular/core';
import { PedidoHistorico } from 'src/app/api';
import { OrderService } from 'src/app/services/order.service';
import { UiRouterState } from 'src/app/services/ajs-router-state.service';

@Component({
  selector: 'mandae-home-collection',
  templateUrl: './collection.component.html',
  styleUrls: ['./collection.component.scss']
})
export class CollectionComponent implements OnInit {

  public latestOpenOrder: PedidoHistorico;

  constructor(private state: UiRouterState,
    private orderService: OrderService) { }

  ngOnInit() {
    this.orderService
      .getLatestOpenOrder()
      .subscribe(response => this.latestOpenOrder = response);
  }

  goToCurrentCollection() {
    this.state.go('pedido.encomendas');
  }

}
